import { memo } from 'react'

import TourV2FAQSection from './TourV2FAQSection'
import { EmptyArray } from 'lib/array/arrayUtils'

interface Props {
  faq?: Array<App.Tours.TourV2OfferFrequentlyAskedQuestion>
}

function TourV2FAQ({ faq = EmptyArray }: Props) {
  return (
    <>
      {faq.map((faqSection, index) => (
        <TourV2FAQSection key={index} FAQItem={faqSection} />
      ))}
    </>
  )
}

export default memo(TourV2FAQ)
